import React from "react";
import { useNavigate } from "react-router-dom";

import "./FloatbuttonContainer.css";

const FloatbuttonContainer = ({ amount, link }) => {
  const navigate = useNavigate();

  return (
    <div className="daBEHU">
      <div className="tip-button-container">
        <a href={link} rel="noopener noreferrer" style={{ textDecoration: 'none' }}>
          <button
            className="bbiTdk bWsdkr"
          >
            Tip ${amount}
          </button>
        </a>
      </div>
    </div>
  );
};

export default FloatbuttonContainer;
